import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Modal from "react-modal"
import { Form } from "react-final-form"
import isEmail from "validator/lib/isEmail"
import styled from "styled-components"
import { StyledForm } from "Styles"
import { theme } from "Theme"
import Config from "Data"
import moment from "moment"
import { HeaderImage, FormHiddenFields, FormDebug, LoadingSpinner, Utils, Link } from "Components"
import { Recaptcha, Input, TextArea, StyledSelect, Spacer } from "Components/FormElements"
const { fontSize } = theme

function ValidateEmail(email) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  if (email.match(validRegex)) {
    return true
  } else {
    return false
  }
}

const emailblockReg =
  /^([\w]+@(?!gmail.com)(?!yahoo.com)(?!ymail.com)(?!hotmail.com)(?!msn.com)(?!aol.com)(?!live.com)(?!icloud.com)(?!me.com)([\w-]+\.)+[\w-]{2,4})?$/

const Container = styled.div`
  position: relative;
  padding: 1rem 1rem 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const PrivacyLink = styled((props) => <Link {...props} />)`
  font-size: ${fontSize.smallish};
  padding: 1rem;
`

const windowGlobal = typeof window !== "undefined" && window

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      loading: false,
      recaptcha: false,
    }
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
  }

  verifyCallback(recaptchaToken) {
    this.setState({ ...this.state, recaptcha: true })
  }

  onLoadRecaptcha() {
    if (this.captchaObject) {
      this.captchaObject.reset()
      this.captchaObject.execute()
    }
  }

  render() {
    const { props } = this
    const {
      showEvents,
      node,
      image,
      brand,
      title,
      subtitle,
      isOpen,
      closeModal,
      onAfterOpen,
      onRequestClose,
      onChangeInput,
    } = props

    let formData = {
      formName: "FormContactUs",
      origin: windowGlobal ? windowGlobal.location.href : "",
      retURL: "/thank-you",
      country: windowGlobal.country,
      brand: Config.brand,
      eventId: showEvents ? null : node ? node.id : "#",
      title: showEvents ? null : node ? `${node.events} | ${moment(node.date).format("MMM Do Y")}` : "#",
      mailingList: "contact_cxosync",
    }

    const toggleLoading = (e) => {
      this.setState({ ...this.state, loading: false })
    }

    const resetRecaptcha = (e) => {
      this.setState({ ...this.state, recaptcha: false })
    }

    function postData(url = ``, data = {}) {
      return fetch(url, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify(data),
      })
        .then((response) => {
          response
            .json()
            .then((data) => {
              resetRecaptcha()
              if (data.retURL) {
                windowGlobal.location = data.retURL
              } else {
                toggleLoading()
                onRequestClose()
              }
            })
            .catch(function (e) {
              console.error("handled the error")
              console.error(e)
            })
        })
        .catch((error) => console.error("Error:", error))
    }

    const onSubmit = async (values) => {
      // console.log(JSON.stringify(values, 0, 2))
      this.setState({ loading: true })
      postData(Utils.endpoints.referee, values).catch((error) => console.error(error))
    }

    const handleChange = (e) => {
      formData[e.target.name] = e.target.value
      this.setState(formData)
    }

    return (
      <StaticQuery
        query={graphql`
          query {
            banners: bannersJson {
              banner {
                contact {
                  childImageSharp {
                    gatsbyImageData(width: 1440, placeholder: BLURRED)
                  }
                }
              }
            }
          }
        `}
        render={(data) => {
          const { loading } = this.state
          const { banner } = data.banners
          return (
            <Modal
              id="modalContactUs"
              contentLabel="modalContactUs"
              closeTimeoutMS={400}
              isOpen={isOpen}
              onAfterOpen={onAfterOpen}
              onRequestClose={onRequestClose}
              shouldFocusAfterRender={true}
              shouldCloseOnOverlayClick={true}
              shouldCloseOnEsc={true}
              shouldReturnFocusAfterClose={true}>
              {!loading && (
                <>
                  <HeaderImage
                    title={title}
                    subtitle={subtitle}
                    subtitle2={`US: ${Config.contact.phone.us}`}
                    subtitle3={`UK: ${Config.contact.phone.uk}`}
                    image={banner.contact}
                  />
                  <button className="btn-close" onClick={closeModal}>
                    X
                  </button>
                </>
              )}

              <Container>
                {loading && <LoadingSpinner />}
                <Form
                  initialValues={formData}
                  onSubmit={onSubmit}
                  validate={(values) => {
                    const errors = {}
                    if (!values.about) {
                      errors.about = "Required"
                    }
                    if (!values.firstName) {
                      errors.firstName = "Required"
                    }
                    if (!values.lastName) {
                      errors.lastName = "Required"
                    }
                    if (!values.email) {
                      errors.email = "Required"
                    } else if (!isEmail(values.email)) {
                      errors.email = "Invalid email"
                    } else if (!ValidateEmail(values.email)) {
                      errors.email = "Not a Company email!"
                    }
                    if (!values.title) {
                      errors.title = "Required"
                    }
                    if (!values.phone) {
                      errors.phone = "Required"
                    }
                    if (!values.company) {
                      errors.company = "Required"
                    }
                    if (!this.state.recaptcha) {
                      errors.recaptcha = "Required"
                    }
                    return errors
                  }}
                  render={({ form, handleSubmit, reset, submitting, pristine, values }) => (
                    <>
                      <StyledForm className="form">
                        <FormHiddenFields hiddenData={formData} />
                        <Input
                          name="firstName"
                          label="First Name"
                          placeholder="First Name"
                          type="text"
                          className="firsthalfWidthElement"
                          required={true}
                        />
                        <Input
                          name="lastName"
                          label="Last Name"
                          placeholder="Last Name"
                          type="text"
                          className="lasthalfWidthElement"
                          required={true}
                        />
                        <Input
                          name="title"
                          label="Title"
                          placeholder="Title"
                          type="text"
                          className="firsthalfWidthElement"
                          required={true}
                        />
                        <Input
                          name="company"
                          label="Company"
                          placeholder="Company"
                          type="text"
                          className="lasthalfWidthElement"
                          required={true}
                        />
                        <Input
                          name="phone"
                          label="Phone"
                          placeholder="Your phone number"
                          className="firsthalfWidthElement"
                          type="tel"
                          onBlur={handleChange}
                          required={true}
                        />
                        <Input
                          name="email"
                          label="Email (Corporate Only)"
                          placeholder="Your email"
                          className="lasthalfWidthElement"
                          type="email"
                          onBlur={handleChange}
                          required={true}
                        />
                        <StyledSelect
                          label="Message about:"
                          name="about"
                          placeholder="Please select one"
                          value={[]}
                          options={[
                            { label: "Attending an Event", value: "attend" },
                            { label: "Sponsorship Info", value: "sponsor" },
                            { label: "Other", value: "other" },
                          ]}
                          defaultMenuIsOpen={false}
                          className="fullWidthElement"
                        />
                        <TextArea
                          name="message"
                          label="More Details"
                          placeholder="Add notes here"
                          type="text"
                          className="messageElement"
                        />

                        <div className="fullWidthElement">
                          <Recaptcha
                            name="Recaptcha"
                            onloadCallback={this.onloadCallback}
                            verifyCallback={this.verifyCallback}
                          />
                        </div>

                        <Spacer />

                        <div className="buttonsWrapper">
                          <button
                            type="button"
                            className="btn"
                            onClick={form.reset}
                            data-gtm={`Form Attend | Reset`}
                            disabled={submitting || pristine}>
                            Clear
                          </button>
                          <button
                            type="submit"
                            className="btn"
                            disabled={submitting || pristine}
                            onClick={handleSubmit}
                            data-gtm={`Form Attend | Submit`}>
                            Submit
                          </button>
                        </div>
                        <div className="footerWrapper">
                          <PrivacyLink to={"/privacy/"} title={`Privacy Policy`}>
                            Privacy Policy
                          </PrivacyLink>
                        </div>
                      </StyledForm>

                      <FormDebug data={values}></FormDebug>
                    </>
                  )}
                />
              </Container>
            </Modal>
          )
        }}
      />
    )
  }
}
